import { Helmet } from 'react-helmet-async';

export default function SEO({
  title,
  description,
  image,
  imageAlt,
  keywords,
  type = 'website',
  url,
}) {
  const siteUrl = 'https://tumanasi.vitaldigitalmedia.net';
  const defaultImage = `${siteUrl}/tumanasi-og-default.png`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url || siteUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || defaultImage} />
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url || siteUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image || defaultImage} />
      {imageAlt && <meta property="twitter:image:alt" content={imageAlt} />}
    </Helmet>
  );
}
